export default "__VITE_ASSET__QiLALNJg__"